import React, { Component, Suspense } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { BlockUI } from "primereact/blockui";
import { withContext } from "../shared/withContext";
import { withRouter } from "react-router";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { isAllreadyReviewed } from "../../parameter";
const Saite2 = React.lazy(() => import("./Saite2"));
class TuningPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0,
        };
        this.blockUi = this.blockUi.bind(this);
        this.nextSaite = this.nextSaite.bind(this);
    }

    render() {
        return (
            <>
                <BlockUI
                    template={
                        <Button
                            icon="pi pi-star"
                            label="Jetzt zur Vollversion wechseln"
                            onClick={() => this.props.history.push("/premium")}
                        />
                    }
                    blocked={this.blockUi() }
                >
                    <TabView
                        className="notestabs"
                        activeIndex={this.state.activeIndex}
                        onTabChange={(e) =>
                            this.setState({ activeIndex: e.index })
                        }
                        scrollable
                        id="saitenliste"
                    >
                        {this.props.activeInstrument.strings.map((tab) => {
                            return (
                                <TabPanel
                                    contentStyle={{ height: "0px" }}
                                    key={tab.note}
                                    header={tab.note}
                                ></TabPanel>
                            );
                        })}
                    </TabView>
                    <Card className="content">
                        <div className="p-d-flex p-jc-center p-mt-1">
                            <Button
                                className="p-button-raised p-button-text model-button"
                                onClick={() => this.props.onSelect(null)}
                            >
                                <div className="p-d-flex p-flex-column">
                                    <span className="w-100">
                                        {this.props.activeInstrument.label}
                                    </span>
                                    <small className="small">(wechseln)</small>
                                </div>
                            </Button>
                        </div>
                        <Suspense fallback={<ProgressSpinner />}>
                            <Saite2
                                blocked={this.blockUi()}
                                string={
                                    this.props.activeInstrument.strings[
                                        this.state.activeIndex
                                    ].note
                                }
                                freq={
                                    this.props.activeInstrument.strings[
                                        this.state.activeIndex
                                    ].freq
                                }
                                reverse={this.props.activeInstrument.reverse}
                                activeInstrument={this.props.activeInstrument}
                                messaging={this.props.messaging}
                                db={this.props.db}
                                setMessage={this.props.setMessage}
                                showAd={
                                    this.state.activeIndex ===
                                    this.props.activeInstrument.strings.length -
                                        1
                                }
                            />
                        </Suspense>
                    </Card>
                </BlockUI>

                <div className="p-d-flex p-jc-center  p-mt-">
                    <Button
                        iconPos="left"
                        icon="pi pi-chevron-left"
                        label="Vorherige Saite"
                        style={{ fontSize: "19px" }}
                        className="p-button-outlined  p-button-secondary"
                        onClick={() => {
                            try {
                                let tab = document.getElementById(
                                    "saitenliste_header_" +
                                        (this.state.activeIndex - 1)
                                );

                                setTimeout(() => {
                                    tab.scrollIntoView({
                                        behavior: "smooth",
                                        block: "center",
                                        inline: "center",
                                    });
                                }, 30);
                            } catch (err) {
                                console.log(err);
                            }

                            this.setState({
                                activeIndex: this.state.activeIndex - 1,
                            });
                        }}
                        disabled={this.state.activeIndex === 0}
                    />
                    <Button
                        iconPos="right"
                        icon="pi pi-chevron-right"
                        label="Nächste Saite"
                        style={{ fontSize: "19px" }}
                        className="p-button-outlined"
                        onClick={this.nextSaite}
                        disabled={
                            this.state.activeIndex ===
                                this.props.activeInstrument.strings.length -
                                    1 || this.blockUi()
                        }
                    />
                </div>
            </>
        );
    }

    nextSaite() {
        try {
            let tab = document.getElementById(
                "saitenliste_header_" + (this.state.activeIndex + 1)
            );

            setTimeout(() => {
                tab.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                });
            }, 30);
        } catch (err) {
            console.log(err);
        }
        this.setState({ activeIndex: this.state.activeIndex + 1 });
        if (
            this.state.activeIndex > 3 &&
            this.state.activeIndex % 2 === 0 &&
            this.props.context.installPrompt
        ) {
            this.props.context.installPrompt.prompt();
        }
    }

    blockUi() {
        return this.state.activeIndex > 10 && !this.props.context.hasPremium && isAllreadyReviewed;
    }
}
export const TuningPageWithoutContext = TuningPage;
export default withRouter(withContext(TuningPage));
